<template>
    <div>
    <rkm-area
        no-margin-top
        title="Filtros"
        type="fieldset"
    >
        <rkm-form
            ref="RkmForm"
        >

        <rkm-row>
            <rkm-col cols="4">
                <rkm-form-date-picker
                    :range-inline="false"
                    end-label="Até"
                    range
                    start-label="Período de"
                    v-model="model.periodo"
                     :start-validations="{ required: true }"
                    :end-validations="{ required: true }"
                />
            </rkm-col>

            <rkm-col cols="4">
                <rkm-form-select
                    @change="loadFrom('profissionalSolicitante')"
                    default-option-text="Todas"
                    :options="form.unidades"
                    label="Unidade"
                    show-default-option
                    text-field="nomeFantasia"
                    v-model="model.infraestruturaId"
                    value-field="infraestruturaId"
                />
            </rkm-col>
            <rkm-col cols="4">
                <rkm-form-select
                    @change="loadFrom('tipoMedicamento')"
                    :options="form.profissionalSolicitante"
                    default-option-text="Todos"
                    label="Profissional Solicitante"
                    show-default-option
                    text-field="nome"
                    v-model="model.profissionalSolicitanteId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>    
            <rkm-col cols="2">
                <rkm-form-select
                    @change="loadMotivos"
                    default-option-text="Todos"
                    :options="form.tiposMedicamento"
                    label="Tipo de Medicamento"
                    show-default-option
                    text-field="descricao"
                    v-model="model.naoPadronizado"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col cols="2">
                <rkm-form-select
                    @change="loadMedicamentos"
                    :disabled="model.naoPadronizado === null"
                    default-option-text="Todos"
                    :options="form.motivos"
                    label="Motivo"
                    show-default-option
                    text-field="nome"
                    v-model="model.motivoId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-select
                    :disabled="model.naoPadronizado === null"
                    :options="form.medicamentos"
                    default-option-text="Todos"
                    label="Medicamento"
                    show-default-option
                    text-field="descricao"
                    v-model="model.medicamentoId"
                    value-field="id"
                />
            </rkm-col>
                <rkm-col>
                    <rkm-form-input-autocomplete
                        :repository="{ autocomplete: repositories.relatorioMedicamentoNaoAtendido.paciente }"
                        :searchFields="pacienteSearchFields"
                        :text-field="p => p.cns ? `${p.cns} - ${p.nome}` : p.nome"
                        :minLength="3"
                        :request-query-string-params="autocompleteParams"
                        label="Paciente"
                        v-model="model.paciente"
                        value-field="id"
                        placeholder="Nome, Nome social, CNS, CPF, Data de nascimento ou Prontuário"
                    />
                </rkm-col> 
                <rkm-col cols="auto">
                    <rkm-button
                        :label="false"
                        @click="$refs.RkmForm.validate(search)"
                        color="primary"
                    >
                        Buscar
                    </rkm-button>

                    <rkm-button
                        :label="false"
                    >
                        Limpar
                    </rkm-button>
                </rkm-col>
        </rkm-row>
            
        </rkm-form>

    </rkm-area>

    <rkm-area
        no-margin-top
        title="Resultado"
    >
        <template v-slot:trailing>
            <rkm-dropdown
                class="mr-2"
                color="primary"
                cols="1"
                menu-class="auto-scroll"
                no-caret
                small
                title="Colunas"
                v-rkm-tooltip.hover
            >
                <template v-slot:button-content>
                    <rkm-icon icon="columns" />
                </template>
                <rkm-form-checkbox
                    :indeterminate="indeterminate"
                    @change="selectAll"
                    class="mx-2"
                    v-model="selectedAll"
                >
                    Todas
                </rkm-form-checkbox>
                
                <rkm-form-checkbox-group
                    :options="optionalColumns"
                    class="mx-2"
                    stacked
                    text-field="label"
                    v-model="selectedColumns"
                    value-field="key"
                />
            </rkm-dropdown>

            <rkm-button
                :disabled="itens.length === 0 || itens.length > 10000"
                @click="print"
                color="info"
                small
                title="Imprimir"
            >
                <rkm-icon icon="print" />
            </rkm-button>
            <rkm-button
                :disabled="itens.length === 0"
                @click="exportTo"
                color="info"
                small
                title="Exportar"
            >
                <rkm-icon icon="file-export" />
            </rkm-button>

            </template>
        <rkm-table
            :fields="fields"
            :foot-clone="itens.length > 0"
            :items="itens"
            :sort-by="sortBy"
            :sort-desc="sortDesc"
            @sort-changed="onSortChanged"
            no-footer-sorting
        >
            <template #foot(dataReceita)>
                <span></span>
            </template>

            <template #foot(paciente)>
                <span></span>
            </template>

            <template #foot(pacienteProntuario)>
                <span></span>
            </template>

            <template #foot(profissionalSolicitante)>
                <span></span>
            </template>

            <template #foot(unidade)>
                <span></span>
            </template>

            <template #foot(tipoMedicamento)>
                <span></span>
            </template>

            <template #foot(medicamento)>
                <span></span>
            </template>

            <template #foot(motivo)>
                <span></span>
            </template>

            <template #foot(justificativa)>
                <span></span>
            </template>

            <template #foot(usuarioRegistro)>
                <span></span>
            </template>

            <template #foot(areaMicroarea)>
                <span></span>
            </template>

            <template #foot(endereco)>
                <span></span>
            </template>

            <template #foot(telefone)>
                <span></span>
            </template>

            <template #foot(quantidade)>
                <span>{{ getSafely(() => totalizadores.quantidade, 0) }}</span>
            </template>

            <template #afterTable v-if="itens.length > 0">
                <rkm-area
                    no-margin-top
                    title="Totalizadores"
                >
                    <rkm-row>
                        <rkm-col cols="4">
                            <rkm-form-input
                                label="Total de receitas não atendidas"
                                :value="totalizadores.receitas"
                                readonly
                            />
                        </rkm-col>

                        <rkm-col cols="4">
                            <rkm-form-input
                                label="Total de pacientes não atendidos"
                                :value="totalizadores.pacientes"
                                readonly
                            />
                        </rkm-col>

                        <rkm-col cols="4">
                            <rkm-form-input
                                label="Total de medicamentos não atendidos"
                                :value="totalizadores.medicamentos"
                                readonly
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </template>
        </rkm-table>
    </rkm-area>
    </div>
</template>


<script>
import { repository, stringCase, object, data, error, file } from '@/mixins'
import moment from "moment";
import { mapActions } from "vuex";
export default {
    computed:{
        validations() {
            return {
                periodo: {
                    start: { required: true },
                    end: { required: true },
                }
            }
        },
        autocompleteParams() {
            return {
                periodo: {
                    start: this.model.periodo.start ? moment(this.model.periodo.start).format('DD/MM/YYYY') : null,
                    end: this.model.periodo.end ? moment(this.model.periodo.end).format('DD/MM/YYYY') : null,
                },
                infraestrutura_id: this.model.infraestruturaId,
                profissional_solicitante_id: this.model.profissionalSolicitanteId,
                nao_padronizado: this.model.naoPadronizado,
                motivo_id: this.model.motivoId,
                medicamento_id: this.model.medicamentoId
            }
        },
        optionalColumns() {
            return this.columns.filter(c => !(c.fixed || false))
        },
        fields() {
            return this.columns.filter(c => (c.fixed || false) || this.selectedColumns.includes(c.key))
        },
        pacienteSearchFields() {
            return [
                { key: 'cidadao.nome', searchable: true },
                { key: 'cidadao.nome_social', searchable: true },
                { key: 'cidadao.cns', searchable: true },
                { key: 'cidadao.cpf', searchable: true },
                { key: 'cidadao.data_nascimento', searchable: true },
                { key: 'paciente.prontuario', searchable: true },
             ]
        },
    },
    created(){
        this.load()
        this.repositories = {
            relatorioMedicamentoNaoAtendido: this.getConectaSusRepository('farmacia.relatorioMedicamentoNaoAtendido'),
            impressao: this.getConectaSusRepository('impressao.farmacia'),
            exportacao: this.getConectaSusRepository('exportacao.farmacia'),
        }
    },
    data() {
        return {
            model: {
                periodo: {
                    start: null,
                    end: null
                },
                infraestruturaId: null,
                profissionalSolicitanteId: null,
                naoPadronizado: null,
                motivoId: null,
                medicamentoId: null,
                paciente: null
            },
            form:{
                unidades: null,
                profissionalSolicitante: null,
                tiposMedicamento: null,
                motivos: null,
                medicamentos: null
            },
            itens: [],
            totalizadores: {
                receitas: 0,
                pacientes: 0,
                medicamentos: 0
            },
            selectedAll: false,
            indeterminate: true,
            selectedColumns: [
                'pacienteProntuario',
                'profissionalSolicitante',
                'unidade',
                'tipoMedicamento',
                'motivo',
                'justificativa',
            ],
            sortBy: null,
            sortDesc: false,
            columns: [
                { key: 'dataReceita', label: 'Data da receita', sortable: true, class: 'col-min text-center', fixed: true },
                { key: 'paciente', label: 'Paciente', sortable: true, fixed: true },
                { key: 'pacienteProntuario', label: 'Prontuário', sortable: true, class: 'col-min text-center' },
                { key: 'profissionalSolicitante', label: 'Profissional solicitante', sortable: true },
                { key: 'unidade', label: 'Unidade', sortable: true },
                { key: 'tipoMedicamento', label: 'Tipo', sortable: true, class: 'col-min text-center' },
                { key: 'medicamento', label: 'Medicamento', sortable: true, fixed: true },
                { key: 'motivo', label: 'Motivo', sortable: true },
                { key: 'justificativa', label: 'Justificativa', sortable: true, class: 'text-break', thStyle: { minWidth: '150px' }, tdStyle: { minWidth: '150px' } },
                { key: 'usuarioRegistro', label: 'Usuário responsável pelo registro', sortable: true },
                { key: 'areaMicroarea', label: 'Área e Microarea', sortable: true },
                { key: 'endereco', label: 'Endereço', sortable: true },
                { key: 'telefone', label: 'Telefone', sortable: true },
                { key: 'quantidade', label: 'Quantidade', sortable: true, class: 'col-min text-center', fixed: true },
            ]
        }
    },
    methods:{
        ...mapActions(["setLoading", "unsetLoading"]),
        addWatchers() {

            this.$watch('model.periodo', {
                deep: true,
                handler(periodo) {

                    if (periodo.start === null || periodo.end === null) {

                        this.resetAfterPeriodo()
                    }
                    else {

                        this.model.infraestruturaId = null
                        this.model.profissionalSolicitanteId = null

                        this.loadFrom('unidade')
                    }
                }
            })
        },
        load(){
            this.addWatchers()
        },
        search(){
            this.setLoading()
            this.repositories.relatorioMedicamentoNaoAtendido.index(this.prepareData())
                .then(({ data }) => {
                    this.itens = data.itens
                    this.totalizadores = data.totalizadores
                })            
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        loadFrom(field){
            this.setLoading()
            this.repositories.relatorioMedicamentoNaoAtendido.list({ ...this.prepareData(), load_from: this.camelToSnake(field) })
                .then(( { data }) => {

                    if (data && data.unidades !== undefined) {

                        this.form.unidades = data.unidades

                        if (data.unidades.length === 1) {
                            this.model.infraestruturaId = data.unidades[0].infraestruturaId;
                        }

                        this.loadFrom('profissionalSolicitante');
                    }

                    if (data && data.profissionalSolicitante !== undefined) {

                        this.form.profissionalSolicitante = data.profissionalSolicitante

                        this.model.profissionalSolicitanteId = data.profissionalSolicitante.length === 1
                            ? data.profissionalSolicitante[0].id
                            : null

                        this.loadFrom('tipoMedicamento')
                    }

                    if (data && data.tiposMedicamento !== undefined) {

                        this.form.tiposMedicamento = data.tiposMedicamento

                        this.model.naoPadronizado = data.tiposMedicamento.length === 1
                            ? data.tiposMedicamento[0].id
                            : null

                        this.loadMotivos()
                    }

                    if (data && data.motivos !== undefined) {

                        this.form.motivos = data.motivos

                        this.model.motivoId = data.motivos.length === 1
                            ? data.motivos[0].id
                            : null

                        this.loadMedicamentos()
                    }

                    if (data && data.medicamentos !== undefined) {
                        this.form.medicamentos = data.medicamentos
                    }
                }
            )
            .catch(this.handleError)
            .finally(() => this.unsetLoading())
        },
        loadMotivos() {

            this.model.motivoId = null
            this.form.motivos = null
            this.model.medicamentoId = null
            this.form.medicamentos = null

            if (this.model.naoPadronizado !== null) {

                this.loadFrom('motivo')
            }
        },
        loadMedicamentos() {

            this.model.medicamentoId = null
            this.form.medicamentos = null

            if (this.model.naoPadronizado !== null) {

                this.loadFrom('medicamento')
            }
        },
        prepareData() {
            const data = this.clone(this.model)
            this.formateDates(data.periodo, ['start', 'end'], 'DD/MM/YYYY')
            this.createIdKeysToObject(data, ['paciente'])
            return this.camelObjectKeysToSnakeRecursive(data)
        },
        resetAfterPeriodo() {

            this.form.unidades = null
            this.form.profissionalSolicitante = null
            this.form.tiposMedicamento = null
            this.form.motivos = null
            this.form.medicamentos = null

            this.model.infraestruturaId = null
            this.model.profissionalSolicitanteId = null
            this.model.naoPadronizado = null
            this.model.motivoId = null
            this.model.medicamentoId = null
            this.model.paciente = null
        },
        prepareDataWithColumns() {

            const data = this.prepareData()

            data.selectedColumns = this.fields.map(f => ({
                key: this.camelToSnake(f.key),
                label: f.label,
                class: f.class
            }))

            data.sort_by = this.sortBy ? this.camelToSnake(this.sortBy) : null
            data.sort_desc = this.sortDesc

            return data
        },
        onSortChanged(context) {

            this.sortBy = context.sortBy
            this.sortDesc = context.sortDesc
        },
        print() {

            this.repositories.impressao.relatorioMedicamentoNaoAtendido(this.prepareDataWithColumns())
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
        },
        exportTo() {

            this.repositories.exportacao.relatorioMedicamentoNaoAtendido(this.prepareDataWithColumns())
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
        },
        selectAll(selected) {

            this.selectedColumns = selected ? this.optionalColumns.map(c => c.key) : []
        }

    },
    mixins: [repository, stringCase, object, data, error, file],
    watch: {
        selectedColumns(newValue) {

            this.selectedAll = newValue.length > 0 && newValue.length == this.optionalColumns.length
            this.indeterminate = newValue.length > 0 && newValue.length != this.optionalColumns.length
        },
    }
}
</script>

<style scoped>
.dropdown >>> .auto-scroll {
    max-height: 400px;
    overflow-y: auto;
    width: 400px;
}
</style>